export { default } from "./useTimeout.mjs";
export { Timeout } from "./useTimeout.mjs";